var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTimeLimit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.766,
    height: 16.06,
    viewBox: "0 0 13.766 16.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-timer",
    "data-name": "Icon material-timer",
    d: "M13.677,1.5H9.089V3.03h4.589Zm-3.059,9.942h1.53V6.853h-1.53Zm6.141-5.055L17.845,5.3a8.449,8.449,0,0,0-1.078-1.078L15.681,5.309a6.882,6.882,0,1,0,1.078,1.078Zm-5.376,9.644a5.353,5.353,0,1,1,5.353-5.353A5.349,5.349,0,0,1,11.383,16.031Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#364436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeLimit);
export default __webpack_public_path__ + "static/media/icon-timeLimit.059987a36a9f1edeb582ced9fdbc4c27.svg";
export { ForwardRef as ReactComponent };